<template>
    <div class="content-box first legal-person" v-loading="pageLoading">
        <steps :current-step="currentStep" :steps="steps"></steps>
        <step1 v-if="currentStepPage == 1" @updateStep="updateStep"></step1>
        <step2 v-if="currentStepPage == 2" @updateStep="updateStep"></step2>
        <step3 v-if="currentStepPage == 3" @updateStep="updateStep"></step3>
        <step4 v-if="currentStepPage == 4" @updateStep="updateStep"></step4>
        <step5 v-if="currentStepPage == 5" @updateStep="updateStep"></step5>
        <step6 v-if="currentStepPage == 6" @updateStep="updateStep"></step6>
        <step7 v-if="currentStepPage == 7" @updateStep="updateStep"></step7>
    </div>
</template>

<script>
import Steps from '../components/steps.vue';
import Step1 from './step1.vue';
import Step2 from './step2.vue';
import Step3 from './step3.vue';
import Step4 from './step4.vue';
import Step5 from './step5.vue';
import Step6 from './step6.vue';
import Step7 from './step7.vue';
export default {
    components: {Steps, Step1, Step2, Step3, Step4, Step5, Step6, Step7},
    data() {
        return {
            step: 2,
            pageLoading: false,
            formData: {},
        };
    },
    computed: {
        steps() {
            const {enterpriseUpgradeType} = this.$store.getters;
            if (enterpriseUpgradeType == 1)
                return [
                    {title: '企业认证', icon: 'icon_info'},
                    {title: '手机号验证', icon: 'icon_phone'},
                    {title: '完成', icon: 'icon_over'},
                ];
            if (enterpriseUpgradeType == 2)
                return [
                    {title: '企业认证', icon: 'icon_info'},
                    {title: '对公打款', icon: 'icon_phone'},
                    {title: '提交委托书', icon: 'icon_phone'},
                    {title: '打款验证', icon: 'icon_phone'},
                    {title: '完成', icon: 'icon_over'},
                ];
            if (enterpriseUpgradeType == 3)
                return [
                    {title: '企业实名', icon: 'icon_info'},
                    {title: '完成', icon: 'icon_over'},
                ];
            return [];
        },
        currentStep() {
            const {enterpriseUpgradeStep} = this.$store.getters;
            return enterpriseUpgradeStep.step;
        },
        currentStepPage() {
            const {enterpriseUpgradeStep} = this.$store.getters;
            return enterpriseUpgradeStep.pageStep;
        },
    },
    created() {
        this.updateStep();
    },
    methods: {
        async updateStep() {
            await this.$store.dispatch('getEnterpriseCertify', true);
        },
    },
};
</script>
<style lang="scss" scoped></style>
